import { render, staticRenderFns } from "./base-footer.vue?vue&type=template&id=473904ae&scoped=true&"
import script from "./base-footer.vue?vue&type=script&lang=js&"
export * from "./base-footer.vue?vue&type=script&lang=js&"
import style0 from "./base-footer.vue?vue&type=style&index=0&id=473904ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473904ae",
  null
  
)

export default component.exports